import React, { useState } from 'react';
import styled from 'styled-components';
import GoogleMapReact from 'google-map-react';

import Section from '../global/section';
import Top from '../top';
import Marker from './map_marker';

const StyledMap = styled.div`
	text-align: center;

	section {
		padding-bottom: 0;
	}

	h2 {
		margin-bottom: 2rem;
	}

	.map {
		height: 25rem;
		width: 100%;
		img {
			width: 30px;
		}
	}
	.not-active {
		position: relative;
		z-index: -1;
	}
`;

export default () => {
	const [showBaloon, setShowBaloon] = useState(
		new Array(locations.length).fill(false)
	);

	const toggleBaloon = (index) => {
		if (showBaloon[index]) {
			setShowBaloon(new Array(locations.length).fill(false));
		} else {
			let temp = new Array(locations.length).fill(false);
			temp[index] = !temp[index];
			setShowBaloon(temp);
		}
	};

	return (
		<StyledMap>
			<Section bg="white">
				<Top color="green">ARCADIA LOCATIONS</Top>
				<h2>Where to Find Us</h2>
				<div className="map">
					<GoogleMapReact
						bootstrapURLKeys={{
							key: 'AIzaSyD_3yjaSZ6sP-AzQJ6TtR1LcsOvUpS7XXk',
						}}
						defaultCenter={{
							lat: 43.73,
							lng: -79.6,
						}}
						defaultZoom={8.9}
						onClick={() =>
							setShowBaloon(new Array(locations.length).fill(false))
						}
					>
						{locations.map((x, i) => (
							<Marker
								key={i}
								lat={x.lat}
								lng={x.lng}
								index={i}
								showBaloon={showBaloon[i]}
								toggleBaloon={toggleBaloon}
								name={x.name}
								address1={x.address1}
								address2={x.address2}
								link={x.link}
							/>
						))}
					</GoogleMapReact>
				</div>
			</Section>
		</StyledMap>
	);
};

const locations = [
	{
		lat: '44.0404655',
		lng: '-79.4527817',
		name: 'Newmarket',
		address1: '16700 Bayview Ave #102',
		address2: 'Newmarket, ON L3X 1W1',
		link: 'https://goo.gl/maps/Cz36eyATmzJiyukv8',
	},
	{
		lat: '43.8994931',
		lng: '-79.4449179',
		name: 'Richmond Hill',
		address1: '11160 Yonge St #22',
		address2: 'Richmond Hill, ON L4S 1H5',
		link: 'https://goo.gl/maps/idzF2MJoaPAQBhXW7',
	},
	{
		lat: '43.7812575',
		lng: '-79.6996737',
		name: 'Brampton North',
		address1: '9960 McVean Dr',
		address2: 'Brampton, ON L6P 2S5',
		link: 'https://goo.gl/maps/X3yn47kVyw8Na3Jt9',
	},
	{
		lat: '43.6899081',
		lng: '-79.8347282',
		name: 'Brampton West',
		address1: '10625 Creditview Rd # 3C',
		address2: 'Brampton, ON L7A 0T4',
		link: 'https://goo.gl/maps/ip9WRWHpVQLFZ6FHA',
	},
	{
		lat: '43.6587132',
		lng: '-79.7270536',
		name: 'Brampton South',
		address1: '7700 Hurontario St #303 ',
		address2: 'Brampton, ON L6Y 4M3',
		link: 'https://goo.gl/maps/tfLzgvZQbgijh8gS9',
	},
	{
		lat: '43.3898928',
		lng: '-79.8238277',
		name: 'Burlington',
		address1: '3450 Dundas St B17',
		address2: 'Burlington, ON L7M 4B8',
		link: 'https://goo.gl/maps/JFAcLyfADzuZQcc59',
	},
	{
		lat: '43.904386',
		lng: '-79.268117',
		name: 'Markham',
		address1: '1250 Castlemore Ave Unit 3B',
		address2: 'Markham, ON L6E 0H7',
		link: 'https://goo.gl/maps/ny5scMVSU44ep3ig8',
	},
	{
		lat: '43.7847277',
		lng: '-79.5647907',
		name: 'Woodbridge',
		address1: '205 Marycroft Ave #6',
		address2: 'Woodbridge, ON L4L 5X8',
		link: 'https://goo.gl/maps/GUyiyEmARkgniygH9',
	},
	{
		lat: '43.8608651',
		lng: '-79.5005465',
		name: 'Maple',
		address1: '1860 Major MacKenzie Dr W #3',
		address2: 'Maple, ON L6A 4R9',
		link: 'https://goo.gl/maps/CbRgPF1P67qmqEyaA',
	},
	{
		lat: '43.9116018',
		lng: '-79.6577315',
		name: 'Nobleton',
		address1: '191 MacTaggart Drive, Unit 5 & 6',
		address2: 'Nobleton, ON, L0G 1N0',
		link: 'https://goo.gl/maps/5wA3aokQ9J8MPqFAA',
	},
];
